export enum LoadState {
  InProcess,
  Complete,
}
